import React, { useState } from 'react';
import { FaDownload } from 'react-icons/fa';
import Button from './shared/Button';


const DownloadButton = ({ processedVideoId }) => {
    const [isLoading, setIsLoading] = useState(false);


    const handleDownload = async () => {
        try {
            setIsLoading(true);
            const response = await fetch(`/api/export_processed_video?processed_video_id=${processedVideoId}`, {
                method: 'GET',
            });

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'processed_video.mp4'); // You can customize the filename
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        }
        catch (error) {
            console.error('Error downloading video:', error);
        }
        finally {
            setIsLoading(false);
        }

    };

    return (
        <Button onClick={handleDownload} className="flex items-center" disabled={false} loading={isLoading}>
            <FaDownload className="mr-2" />
            Download Processed Video
        </Button>
    );
};

export default DownloadButton; 